import { render, staticRenderFns } from "./ProdutoSku.vue?vue&type=template&id=44b8e115&scoped=true&"
import script from "./ProdutoSku.vue?vue&type=script&lang=js&"
export * from "./ProdutoSku.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoSku.vue?vue&type=style&index=0&id=44b8e115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b8e115",
  null
  
)

export default component.exports